import React, {useState} from 'react';

const CartItem = ({product, refresh}) => {
    const [reload, setreload] = useState(false);
    
    const cart = JSON.parse(localStorage.getItem('cart'))
    
    const removeProduct =()=>{
        const cartArray = JSON.parse(localStorage.getItem('cart'))
        if(cartArray.length == 1){
            localStorage.removeItem('cart')
            refresh(!refresh)
        }else{
            const index = cartArray.findIndex( ({_id}) => _id === product._id)
            cartArray.splice(index,1)
            localStorage.setItem('cart', JSON.stringify(cartArray))
            refresh(!refresh)
        }
    }

    const prodExists = ()=>{
        if(cart.find( ({_id}) => _id === product._id)) return true
    }

    return ( 
        <div className="row no-gutters py-2">
            <div className="col-sm-2 p-2">
                <img
                alt={product.name}
                style={{margin: "0 auto", maxHeight: "50px"}} 
                src={product.posterImage ? 'https://new.geticketsonline.com/files/product-images/' + product.posterImage : 'https://cdn1.vectorstock.com/i/thumb-large/46/50/missing-picture-page-for-website-design-or-mobile-vector-27814650.jpg'} className="img-fluid d-block"/>
            </div>
            {console.log(product)}
            <div className="col-sm-4 p-2  align-content-center">
                <h5 className="mb-1">{product.name}</h5>
                <p className="mb-1">Price: {product.price}€ </p>
                <p className="mb-1">Date: {product.checkinFrom.split('T')[0]} </p>
            </div>
            <div className="col-sm-2 p-2 text-center align-content-center">
                 <p className="mb-0">Qty: {prodExists() ? cart.find( ({_id}) => _id === product._id).qt : null}</p>
            </div>
            <div className="col-sm-4 p-2 text-right align-content-center">
                {
                    prodExists() ?
                     <button
                    onClick={() => removeProduct()}
                    className="btn btn-danger btn-sm mb-1">
                        <i className='fa fa-trash mr-1' width={"20px"}/>
                    </button>
                    :null
                 }
            </div>
        </div>
     );
     
}
 
export default CartItem;